export const SEND_EMAIL_OPEN = 'SEND_EMAIL_OPEN'
export const SEND_EMAIL_CLOSE = 'SEND_EMAIL_CLOSE'

export const SEND_EMAIL_SET_STATE = 'SEND_EMAIL_SET_STATE'

export const SEND_EMAIL_TOGGLE_COLLAPSE = 'SEND_EMAIL_TOGGLE_COLLAPSE'

export const SEND_EMAIL_CREATE_DRAFT_REQUESTED =
  'SEND_EMAIL_CREATE_DRAFT_REQUESTED'
export const SEND_EMAIL_CREATE_DRAFT_SUCCESS = 'SEND_EMAIL_CREATE_DRAFT_SUCCESS'
export const SEND_EMAIL_CREATE_DRAFT_ERROR = 'SEND_EMAIL_CREATE_DRAFT_ERROR'

export const SEND_EMAIL_IS_COLLAPSED = 'SEND_EMAIL_IS_COLLAPSED'

export const SEND_EMAIL_UPDATE_DRAFT_REQUESTED =
  'SEND_EMAIL_UPDATE_DRAFT_REQUESTED'
export const SEND_EMAIL_UPDATE_DRAFT_SUCCESS = 'SEND_EMAIL_UPDATE_DRAFT_SUCCESS'
export const SEND_EMAIL_UPDATE_DRAFT_ERROR = 'SEND_EMAIL_UPDATE_DRAFT_ERROR'

export const SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED =
  'SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED'
export const SEND_EMAIL_UPDATE_ATTACHMENTS_SUCCESS =
  'SEND_EMAIL_UPDATE_ATTACHMENTS_SUCCESS'
export const SEND_EMAIL_UPDATE_ATTACHMENTS_ERROR =
  'SEND_EMAIL_UPDATE_ATTACHMENTS_ERROR'

export const SEND_EMAIL_DELETE_DRAFT_REQUESTED =
  'SEND_EMAIL_DELETE_DRAFT_REQUESTED'
export const SEND_EMAIL_DELETE_DRAFT_SUCCESS = 'SEND_EMAIL_DELETE_DRAFT_SUCCESS'
export const SEND_EMAIL_DELETE_DRAFT_ERROR = 'SEND_EMAIL_DELETE_DRAFT_ERROR'

export const SEND_EMAIL_REQUESTED = 'SEND_EMAIL_REQUESTED'
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR'

export const SEND_EMAIL_REPLY_OR_FORWARD_REQUESTED =
  'SEND_EMAIL_REPLY_OR_FORWARD_REQUESTED'
export const SEND_EMAIL_REPLY_OR_FORWARD_SUCCESS =
  'SEND_EMAIL_REPLY_OR_FORWARD_SUCCESS'
export const SEND_EMAIL_REPLY_OR_FORWARD_ERROR =
  'SEND_EMAIL_REPLY_OR_FORWARD_ERROR'

export const SEND_EMAIL_FETCH_RECIEPT_REQUESTED =
  'SEND_EMAIL_FETCH_RECIEPT_REQUESTED'
export const SEND_EMAIL_FETCH_RECIEPT_SUCCESS =
  'SEND_EMAIL_FETCH_RECIEPT_SUCCESS'
export const SEND_EMAIL_FETCH_RECIEPT_ERROR = 'SEND_EMAIL_FETCH_RECIEPT_ERROR'

export const SEND_EMAIL_UPDATE_RECIPIENTS_REQUESTED =
  'SEND_EMAIL_UPDATE_RECIPIENTS_REQUESTED'
export const SEND_EMAIL_UPDATE_RECIPIENTS_SUCCESS =
  'SEND_EMAIL_UPDATE_RECIPIENTS_SUCCESS'
export const SEND_EMAIL_UPDATE_RECIPIENTS_ERROR =
  'SEND_EMAIL_UPDATE_RECIPIENTS_ERROR'

export const SEND_EMAIL_UPDATE_MANY_RECIPIENTS_REQUESTED =
  'SEND_EMAIL_UPDATE_MANY_RECIPIENTS_REQUESTED'
export const SEND_EMAIL_UPDATE_MANY_RECIPIENTS_SUCCESS =
  'SEND_EMAIL_UPDATE_MANY_RECIPIENTS_SUCCESS'
export const SEND_EMAIL_UPDATE_MANY_RECIPIENTS_ERROR =
  'SEND_EMAIL_UPDATE_MANY_RECIPIENTS_ERROR'

export const SEND_EMAIL_REMOVE_RECIPIENT_REQUESTED =
  'SEND_EMAIL_REMOVE_RECIPIENT_REQUESTED'
export const SEND_EMAIL_REMOVE_RECIPIENT_SUCCESS =
  'SEND_EMAIL_REMOVE_RECIPIENT_SUCCESS'

export const SEND_EMAIL_SET_CREATE_CONTACT = 'SEND_EMAIL_SET_CREATE_CONTACT'
export const SEND_EMAIL_CREATE_CONTACT_REQUESTED =
  'SEND_EMAIL_CREATE_CONTACT_REQUESTED'
export const SEND_EMAIL_CREATE_CONTACT_SUCCESS =
  'SEND_EMAIL_CREATE_CONTACT_SUCCESS'
export const SEND_EMAIL_CREATE_CONTACT_FAILED =
  'SEND_EMAIL_CREATE_CONTACT_FAILED'

export const SEND_EMAIL_RESET = 'SEND_EMAIL_RESET'

export const SEND_EMAIL_UPDATE_SENDING_STATUS_REQUESTED =
  'SEND_EMAIL_UPDATE_SENDING_STATUS_REQUESTED'
export const SEND_EMAIL_UPDATE_SENDING_STATUS_SUCCESS =
  'SEND_EMAIL_UPDATE_SENDING_STATUS_SUCCESS'
export const SEND_EMAIL_UPDATE_SENDING_STATUS_ERROR =
  'SEND_EMAIL_UPDATE_SENDING_STATUS_ERROR'

export const SEND_EMAIL_REFETCH_SENDING_STATUS_REQUESTED =
  'SEND_EMAIL_REFETCH_SENDING_STATUS_REQUESTED'
export const SEND_EMAIL_REFETCH_SENDING_STATUS_SUCCESS =
  'SEND_EMAIL_REFETCH_SENDING_STATUS_SUCCESS'

export const SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_REQUESTED =
  'SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_REQUESTED'
export const SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_SUCCESS =
  'SEND_EMAIL_RECIPIENTS_TO_LOADING_LIST_SUCCESS'

export const SEND_EMAIL_IS_DRAFT_UPDATING = 'SEND_EMAIL_IS_DRAFT_UPDATING'
